import React, { useState, useMemo } from 'react';
import classnames from 'classnames';
import ReactSelect from 'react-select';

import css from './Select.css';

export const valueToOption = (v, options) => (v.value ? v : options.find((o) => o.value == v));

export const Select = ({ name, value, label, onChange = () => {}, options, className, hideOnPrint }) => {
	const handleChange = (selectedOption, a, b) => {
		onChange(selectedOption, a, b);
	};

	return (
		<div className={classnames(className, 'select__wrapper')}>
			{label && <label>{label}</label>}
			<ReactSelect
				value={value}
				onChange={handleChange}
				isClearable={false}
				name="colors"
				options={options}
				classNamePrefix="select"
			/>
			{hideOnPrint ? null : (
				<div className={'select__print-label'}>
					<strong>{label}: </strong> {value}
				</div>
			)}
		</div>
	);
};
export default React.memo(Select);
